import {DAYS_OF_WEEK_SHORT_LIST, MONTH_SORTED_LIST} from 'core/constants';
import dayjs from 'dayjs';
import {IEventsFilterResponseMeta} from 'modules/events/types';

export interface IEventsCalendarItem {
    dateString: string;
    day: number;
    dayOfWeek: string;
    eventsCount: number;
    isStartOfMonth: boolean;
    isWeekend: boolean;
    month: string;
}

const MONTH_COUNT = 3;

export class EventsCalendar {
    private readonly isWeekend = (dayOfWeekIndex: number): boolean => {
        return 0 === dayOfWeekIndex || 6 === dayOfWeekIndex;
    };

    private createCalendarItem(
        date: Date,
        today: Date,
        calendarData?: IEventsFilterResponseMeta['calendar'],
        // filterDates: IEventsFilterDate[] = [],
        // filtersFromUrl: IEventFilter[] = []
    ): IEventsCalendarItem {
        const day = date.getDate();
        const dayOfWeekIndex = date.getDay();
        const dayOfWeek = DAYS_OF_WEEK_SHORT_LIST[dayOfWeekIndex];
        const month = MONTH_SORTED_LIST[date.getMonth()];
        const dateString = date.toDateString();

        const currentDateFilterKey = dayjs(date).format('YYYY-MM-DD');
        const currentDateFilter = calendarData?.find(({date: filterDate}) => filterDate === currentDateFilterKey);

        return {
            dateString,
            day,
            dayOfWeek,
            eventsCount: currentDateFilter?.count ?? 0,
            isStartOfMonth: dateString === today.toDateString() || 1 === day,
            isWeekend: this.isWeekend(dayOfWeekIndex),
            month,
        };
    }

    public getCalendar(
        calendarData: IEventsFilterResponseMeta['calendar'],
        // filterDates?: IEventsFilterDate[],
        // filtersFromUrl?: IEventFilter[]
    ): IEventsCalendarItem[] {
        const calendar: IEventsCalendarItem[] = [];
        const today = new Date();
        const endDate = new Date();
        endDate.setMonth(today.getMonth() + MONTH_COUNT);

        const currentDate = new Date(today);

        // eslint-disable-next-line no-unmodified-loop-condition
        while (currentDate <= endDate) {
            calendar.push(this.createCalendarItem(currentDate, today, calendarData));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return calendar;
    }
}
